import { context } from '@wikia/ad-engine';

export function getKargoContext(): object {
	const midBoxAdConfigs = context.get('options.replaceOpenWebWithMidBoxAd')
		? {
				mid_boxad: {
					size: [[300, 250]],
					placementId: '_dPZFwGC1X8',
				},
			}
		: {};

	return {
		enabled: false,
		slots: {
			fandom_dt_galleries: {
				sizes: [[728, 90]],
				placementId: '_iZy3mUblxi',
			},
			...midBoxAdConfigs,
		},
	};
}
